export const InsightsIcon = () => {
	return <img src="/insights.svg" alt="Insights Icon" />;
};
